import { render, staticRenderFns } from "./Lipi.vue?vue&type=template&id=8658b0e0&scoped=true&"
import script from "./Lipi.vue?vue&type=script&lang=js&"
export * from "./Lipi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8658b0e0",
  null
  
)

export default component.exports